import Immutable from 'immutable';
import {
  POST_UPDATE,
  POST_SET_MANY,
  POST_REMOVED,
  UPDATE_LATEST_POST_FOR_BLOCK,
  PORTFOLIO_POST_SET_MANY,
  UPDATE_COMMENT_COUNT,
} from './actions';
import {
  SET_BLOCK_FEED_DATA,
  APPEND_BLOCK_FEED_DATA,
  PREPEND_BLOCK_FEED_DATA,
  FEED_DATA_FETCH_SUCCESS,
  FEED_DATA_REFRESH_SUCCESS,
  FEED_DATA_LOAD_MORE_SUCCESS,
} from '../Feeds/actions';
import {
  NOTIFICATION_READ_FETCH_SUCCESS,
  NOTIFICATION_READ_REFRESH_SUCCESS,
  NOTIFICATION_READ_LOAD_MORE_SUCCESS,
  NOTIFICATION_UNREAD_FETCH_SUCCESS,
  NOTIFICATION_UNREAD_REFRESH_SUCCESS,
  NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS,
} from '../Notifications/actions';
import { FETCH_NOTIFICATION_DETAIL_SUCCESS } from '../PushNotification/actions';
import { LOGOUT_SUCCESS } from '../Auth/actions';
import {
  PORTFOLIO_QUERY_COMPLETE,
  FETCH_GALLERY_POSTS_SUCCESS,
} from '../Galleries/actions';
import { GET_LINKED_NOTIFICATION_DATA } from '../LinkedNotification/actions';
import { BLOCKPAGE_DATA_LOADED_SUCCESS } from '../BlockPageUI/actions';

const DEFAULT_STATE = Immutable.fromJS({
  byId: {},
  byUser: {},
});

const setLatestPosts = (state, action) => {
  // update latest post for a block
  const { viewedByUserId, blockId, postType, postId } = action;

  return state.setIn(
    ['latestPosts', viewedByUserId, blockId, postType],
    postId
  );
};

export function Posts(state = DEFAULT_STATE, action) {
  switch (action.type) {
    case POST_UPDATE: {
      const { postId, changes } = action;
      const modifiedPost = state
        .getIn(['byId', postId], Immutable.Map())
        .merge(Immutable.fromJS(changes));
      return state.setIn(['byId', postId], modifiedPost);
    }
    case APPEND_BLOCK_FEED_DATA:
    case PREPEND_BLOCK_FEED_DATA:
    case SET_BLOCK_FEED_DATA:
    case POST_SET_MANY:
    case GET_LINKED_NOTIFICATION_DATA:
    case PORTFOLIO_POST_SET_MANY:
    case PORTFOLIO_QUERY_COMPLETE:
    case NOTIFICATION_READ_FETCH_SUCCESS:
    case NOTIFICATION_READ_REFRESH_SUCCESS:
    case NOTIFICATION_READ_LOAD_MORE_SUCCESS:
    case NOTIFICATION_UNREAD_FETCH_SUCCESS:
    case NOTIFICATION_UNREAD_REFRESH_SUCCESS:
    case NOTIFICATION_UNREAD_LOAD_MORE_SUCCESS:
    case FEED_DATA_FETCH_SUCCESS:
    case FEED_DATA_REFRESH_SUCCESS:
    case FEED_DATA_LOAD_MORE_SUCCESS:
    case FETCH_GALLERY_POSTS_SUCCESS:
    case FETCH_NOTIFICATION_DETAIL_SUCCESS: {
      const { posts } = action;
      const postsById = {};

      // Convert it to a dict so we can merge into the state
      posts.forEach((post) => (postsById[post.id] = post));

      return state.set(
        'byId',
        state.get('byId').merge(Immutable.fromJS(postsById))
      );
    }
    case BLOCKPAGE_DATA_LOADED_SUCCESS: {
      const { exhibitUser, exhibitPosts, blockData } = action;
      if (!exhibitUser || !exhibitPosts) {
        return state;
      }
      const viewedByUserId = exhibitUser.get('id');
      let newState = state;

      // Clear out the latestPostsForUser for all relevant blocks
      // This avoids the problem on group space pages where a user
      // switches groups and the latest post information
      // for the displayed blocks is stale
      blockData.blockList.forEach((block) => {
        const blockId = block.id;

        const exhibitPostTypes = exhibitPosts.posts[blockId];
        ['share', 'submit'].forEach((postType) => {
          const latestPostAction = {
            viewedByUserId,
            blockId,
            postType,
            // clear postId by default
            postId: null,
          };
          if (exhibitPostTypes) {
            const post = exhibitPostTypes[postType];
            if (post) {
              // set postId if available
              latestPostAction.postId = post.id;
            }
          }
          newState = setLatestPosts(newState, latestPostAction);
        });
      });

      const postsById = {};
      Object.values(exhibitPosts.posts).forEach((types) => {
        Object.values(types).forEach((post) => {
          if (post) {
            postsById[post.id] = post;
          }
        });
      });

      return newState.set(
        'byId',
        newState.get('byId').merge(Immutable.fromJS(postsById))
      );
    }
    case POST_REMOVED: {
      return state.removeIn(['byId', action.postId]);
    }
    case UPDATE_LATEST_POST_FOR_BLOCK: {
      return setLatestPosts(state, action);
    }
    case UPDATE_COMMENT_COUNT: {
      const { postId } = action;
      const keyPath = ['byId', postId, 'commentsCount'];
      const currentCount = state.getIn(keyPath, 0);
      return state.setIn(keyPath, currentCount + 1);
    }
    case LOGOUT_SUCCESS: {
      return DEFAULT_STATE;
    }
    default: {
      return state;
    }
  }
}
